<div class="page">
  <div class="container">
  <!-- Left Column -->
  <div class="left-panel">
    <div class="left-content">
      <h1 class="promo-heading">{{ 'CREATE_ACCOUNT.PROMO_HEADING' | translate }}</h1>
      <p class="promo-subtitle">
        {{ 'CREATE_ACCOUNT.PROMO_SUBTITLE' | translate }}
      </p>
    </div>
    <div class="illustration-wrapper">
      <img
        class="illustration"
        src="/assets/images/create-account.png"
        alt="Investment illustration"
      />
    </div>
    <div class="logo-blur"></div>
    <div class="logo-wrapper">
      <img class="panel-logo" src="/assets/images/cube_logo_dark.png" alt="Logo" />
    </div>
  </div>

  <!-- Right Column -->
  <div class="right-panel">
    <div class="form-container">
      <div class="form-header">
        <h2 class="form-heading">{{ 'CREATE_ACCOUNT.HEADING' | translate }}</h2>
        <div class="form-header-actions">
          <app-language-selector></app-language-selector>
          <app-theme-toggle />
        </div>
      </div>
      <p class="form-subtitle">{{ 'CREATE_ACCOUNT.SUBTITLE' | translate }}</p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-fields">
          <app-input
            [label]="'CREATE_ACCOUNT.EMAIL_LABEL' | translate"
            [placeholder]="'CREATE_ACCOUNT.EMAIL_PLACEHOLDER' | translate"
            type="email"
            formControlName="email"
            name="email"
            autocomplete="email"
            [errorText]="emailError"
          ></app-input>

          <app-input
            [label]="'CREATE_ACCOUNT.PASSWORD_LABEL' | translate"
            [placeholder]="'CREATE_ACCOUNT.PASSWORD_PLACEHOLDER' | translate"
            [type]="showPassword() ? 'text' : 'password'"
            formControlName="password"
            name="new-password"
            autocomplete="new-password"
            [errorText]="passwordError"
            (inputFocus)="onPasswordFocus()"
            (inputBlur)="onPasswordBlur()"
          >
            <button
              inputSuffix
              type="button"
              class="password-toggle-btn"
              (click)="togglePassword()"
              tabindex="-1"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
            >
              @if (showPassword()) {
                <img src="assets/icons/eye-open.svg" alt="" width="20" height="20" />
              } @else {
                <img src="assets/icons/eye-closed.svg" alt="" width="20" height="20" />
              }
            </button>
          </app-input>

          <app-input
            [label]="'CREATE_ACCOUNT.CONFIRM_PASSWORD_LABEL' | translate"
            [placeholder]="'CREATE_ACCOUNT.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
            [type]="showConfirmPassword() ? 'text' : 'password'"
            formControlName="confirmPassword"
            name="confirm-password"
            autocomplete="new-password"
            [errorText]="confirmPasswordError"
            (inputFocus)="onPasswordFocus()"
            (inputBlur)="onPasswordBlur()"
          >
            <button
              inputSuffix
              type="button"
              class="password-toggle-btn"
              (click)="toggleConfirmPassword()"
              tabindex="-1"
              [attr.aria-label]="showConfirmPassword() ? 'Hide password' : 'Show password'"
            >
              <img class="toggle-icon" [src]="showConfirmPassword() ? (isDark() ? 'assets/icons/eye-open-dark.svg' : 'assets/icons/eye-open.svg') : (isDark() ? 'assets/icons/eye-closed-dark.svg' : 'assets/icons/eye-closed.svg')" alt="" />
            </button>
          </app-input>

          @if (showPasswordStrength() || passwordValue) {
            <app-password-strength
              [password]="passwordValue"
            ></app-password-strength>
          }

          <app-checkbox formControlName="termsAccepted">
            <span class="checkbox-label">
              {{ 'CREATE_ACCOUNT.TERMS_TEXT' | translate }}
              <a [href]="termsUrl" target="_blank" rel="noopener noreferrer"
                >{{ 'CREATE_ACCOUNT.TERMS_LINK' | translate }}</a
              >.
            </span>
          </app-checkbox>


          <app-button
            [label]="'CREATE_ACCOUNT.BUTTON' | translate"
            [disabled]="!isFormValid"
            [loading]="loading()"
            type="submit"
          ></app-button>
        </div>
      </form>

      <div class="divider">
        <span>{{ 'COMMON.OR' | translate }}</span>
      </div>

      <div class="social-buttons">
        <app-google-button [label]="'CREATE_ACCOUNT.GOOGLE' | translate" (btnClick)="onGoogleLogin()" />
        <app-apple-button [label]="'CREATE_ACCOUNT.APPLE' | translate" (btnClick)="onAppleLogin()" />
      </div>

      <p class="sign-in-link">
        {{ 'CREATE_ACCOUNT.HAS_ACCOUNT' | translate }}
        <a [routerLink]="langService.langUrl('/sign-in')">{{ 'CREATE_ACCOUNT.SIGN_IN' | translate }}</a>
      </p>
    </div>
  </div>
  </div>
</div>

